export const useRound = () => {
    const roundTo = (number: string, places = 2): string => {
        return Number(number).toFixed(places)
    }

    return { roundTo }
}
